import styled from "styled-components";

// eslint-disable-next-line import/prefer-default-export
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .radio-group {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .grid-form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
  }

  .action-container {
    gap: 1rem;
    display: flex;
    justify-content: flex-end;
  }
`;
